module.exports = __webpack_public_path__ + "static/img/about_cooperate_05_zh.4301fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_cooperate_05_zh.png
// module id = aUlC
// module chunks = 34